<template>
  <div class="main-wrapper">
    <p class="recomend-browsers">
      При заполнении анкеты рекомендуется использовать браузеры: Chrome, Opera,
      FireFox
    </p>
    <input
      id="taxpayerNumberInput"
      class="input-inn"
      v-model="inputINN"
      v-mask="'############'"
      :class="validateINN() ? 'valid' : 'unvalid'"
      :disabled="!hasEsia"
      @input="onChangeINN()"
      :placeholder="
        withDigitalKey ? 'Вставьте токен' : 'Введите ИНН (10 или 12 цифр)'
      "
      v-if="true"
    />
    <dropdown
      :options="dropDownArr"
      :selected="this.selected"
      v-on:updateOption="onSelectINN"
      v-if="false"
    ></dropdown>
    <p>Если вы продолжаете заполнять ранее введенную анкету, для входа укажите токен,<br/> направленный вам на e-mail, указанный в анкете.</p>
    <input
      id="continueTokenInput"
      class="input-continue-token"
      v-model="continueToken"
      v-mask="'############'"
      :class="
        validateContinueToken() || continueToken.length == 0
          ? 'valid'
          : 'unvalid'
      "
      :disabled="!hasEsia"
      @input="onChangeToken()"
      placeholder="Укажите токен для продолжения заполнения анкеты"
      v-if="true"
    />
    <p>Уважаемый клиент!</p>
    <p v-if="withDigitalKey">
      Для заполнения анкеты используйте действующий ТОКЕН с квалифицированной
      ЭП,
      <br />
      это сэкономит время от начала заполнения анкеты до открытия счета в ПАО
      «РосДорБанк».<br />
      Мы заботимся о своих клиентах.
    </p>
    <p>
      Для оперативного заполнения анкеты рекомендуем вам заранее приготовить
      документы и информацию, запрашиваемую в анкете.
    </p>
    <a v-if="hasEsia && false" :href="aUrl"
      >Войти с помощью ЕСИА (Только для ИП)</a
    >
    <InputInnInfo />
  </div>
</template>

<script>
import dropdown from "vue-dropdowns";
import InputInnInfo from "./widgets/v-input-inn-info.vue";
import { now } from "moment";

export default {
  name: "InputINN",
  components: { dropdown, InputInnInfo },
  props: {
    pageInfo: {},
    userINN: String,
    url: String,
    hasEsia: Boolean,
    innArray: Array,
    withDigitalKey: Boolean,
  },
  data() {
    return {
      inputINN: "",
      continueToken: "",
      aUrl: "/idrdb/esia?auth=1&sessionId=215&callback=testesia.html",
      dropDownArr: [],
      selectedCompany: "",
      selected: {},
    };
  },
  created() {
    this.inputINN = this.userINN;
    this.aUrl = this.url + this.aUrl;
    this.validate();

    this.innArray.forEach((element) => {
      this.dropDownArr.push({ name: element.OGRN + " " + element.ORG_NAME });
    });
    if (this.innArray.length > 0) {
      this.inputINN = this.innArray[0].OGRN;
      this.selected = { name: this.innArray[0].OGRN };
    }
    if (this.withDigitalKey) {
      if (this.checkCryptoPlugin())
        this.$alert("Вставьте ТОКЕН квалифицированной ЭП ");
    }
  },
  methods: {
    validateINN() {
      return this.inputINN.length == 10 || this.inputINN.length == 12;
    },
    validateContinueToken() {
      return this.continueToken.length == 12;
    },
    validate() {
      var msg = "";
      if (!this.validateINN()) {
        msg += "Введите ИНН<br/>";
      }
      if (this.continueToken.length > 0 && !this.validateContinueToken()) {
        msg += "Корректно введите токен для продолжения заполнения анкеты";
      }
      this.$emit("validate", false, msg);
      if (msg.length == 0) {
        if (this.validateContinueToken()) {
          this.changeSendData(this.inputINN, this.continueToken);
        } else {
          this.changeSendData(this.inputINN, this.createToken());
        }
      }
      return msg.length == 0;
    },
    createToken() {
      var token = "";
      var nowTime = now().toString();
      token += this.inputINN.substr(this.inputINN.length - 4, 4);
      token += nowTime.substr(nowTime.length - 4, 4);
      token += this.inputINN.substr(0, 4);
      return token;
    },
    changeSendData(inn, continueToken) {
      this.$emit(
        "changePageSendData",
        {
          INN: inn,
          CONTINUE_TOKEN: continueToken,
        },
        false
      );
    },
    onChangeINN() {
      this.validate();
    },
    onChangeToken() {
      this.validate();
    },
    onSelectINN(event) {
      this.inputINN = event.name.substr(0, event.name.indexOf(" "));
      event.name = this.inputINN;
      this.dropDownArr = [];
      this.innArray.forEach((element) => {
        this.dropDownArr.push({ name: element.INN + " " + element.ORG_NAME });
      });
    },
    checkCryptoPlugin() {
      if (window.isEdge()) {
        window.ShowEdgeNotSupported();
        return false;
      } else {
        var canPromise = window.Promise;
        if (canPromise) {
          window.cadesplugin.then(
            function() {
              window.Common_CheckForPlugIn();
            },
            (error) => {
              console.log(error);
              this.$confirm(
                "Для работы КриптоПро ЭЦП Browser plugin необходимо установить расширение. Перейти на сайт Крипто Про для загрузки?"
              ).then((isAccepted) => {
                if (isAccepted)
                  window.open(
                    "https://www.cryptopro.ru/products/cades/plugin",
                    "_blank"
                  );
              });
            }
          );
        } else {
          console.log("КриптоПро ЭЦП Browser plugin не поддрежвается!");
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style scoped>
input {
  border: 1px solid #cccccc;
  border-radius: 7px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -khtml-border-radius: 3px;
  background: #ffffff;
  border-radius: 6px;
  outline: none;
  height: 50px;
  font-size: 15px;
  text-align: center;
  width: 400px;
}
p {
  font-size: 11pt;
}
a {
  padding: 2px 3px;
  color: #06569b;
  text-decoration: underline;
}
.unvalid {
  border: 1px solid red;
  border-radius: 7px;
}
.recomend-browsers {
  color: #85b0f8;
}
</style>
